import { useState, useCallback } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { switchEndpoint } from "../../../../../../redux/actions/endpoints";
import { storage } from "../../../../../../scopedStorage";

const usePickUpTransaction = ({ initiateDetails, onSuccess }) => {
  const [loading, setLoading] = useState(false);

  const initiateTransaction = useCallback(
    async ({ wastePayload, paymentMethod, hasErrors }) => {
      if (hasErrors) {
        toast.error("Please fix the invalid kg values before submitting", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
        return;
      }

      if (!wastePayload.length) {
        toast.error("Please enter weight for at least one category", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
        return;
      }

      if (!paymentMethod) {
        toast.error("Kindly select a payment method", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
        return;
      }

      setLoading(true);
      const token = storage.getItem("token");

      const payload = {
        waste_category: wastePayload,
        pickup_id: initiateDetails?.id,
        payment_method: paymentMethod,
        request_type: "pickup",
      };

      try {
        const response = await axios.post(
          `${switchEndpoint}/driver/start-pickup-transaction`,
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        localStorage.setItem("pickUp", JSON.stringify(response.data));
        onSuccess();
      } catch (error) {
        toast.error(error.response?.data?.message || "Something went wrong", {
          position: "top-right",
          autoClose: 5000,
          theme: "light",
        });
      } finally {
        setLoading(false);
      }
    },
    [initiateDetails, onSuccess]
  );

  return { loading, initiateTransaction };
};

export default usePickUpTransaction;